// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"referral-message_messageBox__1xjfJ","fadeIn":"referral-message_fadeIn__mpwYW","fadeOut":"referral-message_fadeOut__PDgdy"};